import checkoutClasses from "web/Pages/Checkout/Success/success.scss";

import { ErrorComponentWithContainer } from "web/Layout/Common/ErrorComponent";
import Image from "web/Layout/Common/Image/image";
import Loading from "web/Layout/Common/Loading";
import __ from "web/Layout/Translations";
import { getLanguageCode } from "web/Layout/Translations/LanguageWrapper";

import Button from "web/Components/Common/Button";

import bannerEng from "web/assets/images/orderConfirmationBanner-eng.jpg";
import bannerEngWebp from "web/assets/images/orderConfirmationBanner-eng.webp";
import bannerPl from "web/assets/images/orderConfirmationBanner.jpg";
import bannerPlWebp from "web/assets/images/orderConfirmationBanner.webp";

import canUseWebp from "web/utils/system/DOM/media/canUseWebp";

import { IPrepaidOrder } from "web/types/PrepaidCard";

import {
  useGetPrepaidCardOrderDetailsQuery,
  useGetPrepaidCardsOrdersQuery,
} from "web/features/prepaidCardsOrders/prepaidCardsOrdersApiSlice";

import OrderDetails from "../OrderDetails";
import OrderSummary from "../OrderSummary";
import classes from "./success.scss";

type SuccessProps = {
  orderId: string;
};

const Success = ({ orderId }: SuccessProps) => {
  const currentLanguage = getLanguageCode();
  const webpStatus = canUseWebp();

  const bannerEngSrc = webpStatus ? bannerEngWebp : bannerEng;
  const bannerPlSrc = webpStatus ? bannerPlWebp : bannerPl;

  const isEnglish = currentLanguage === "en";
  const bannerSrc = isEnglish ? bannerEngSrc : bannerPlSrc;
  const bannerAlt = isEnglish
    ? "Thank you for your purchase."
    : "Dziękujemy za dokonanie zakupu.";

  const {
    data: orders,
    isLoading: isLoadingOrders,
    error: ordersError,
  } = useGetPrepaidCardsOrdersQuery();
  const order = orders?.find((order: IPrepaidOrder) => order.id === orderId);

  const {
    data: orderDetails,
    isLoading: isLoadingOrderDetials,
    error: orderDetailsError,
  } = useGetPrepaidCardOrderDetailsQuery(orderId);

  if (ordersError || orderDetailsError) {
    return <ErrorComponentWithContainer />;
  }

  if (isLoadingOrders || isLoadingOrderDetials) {
    return <Loading className={classes.loading} />;
  }

  return (
    <div className={checkoutClasses.root}>
      <div className={checkoutClasses.order}>
        <Image
          src={bannerSrc}
          alt={bannerAlt}
          className={checkoutClasses.banner}
        />

        {order && (
          <OrderSummary
            totalAmount={order.employeeTotalAmount}
            orderNumber={order.orderNumber}
          />
        )}

        <div className={checkoutClasses.wrapper}>
          <div>
            <h2
              className={checkoutClasses.header}
              data-t1="success_page_details_header"
            >
              {__("Szczegóły zamówienia")}
            </h2>
          </div>
        </div>

        {orderDetails && (
          <div className={classes.orderDetailsContainer}>
            <OrderDetails orderDetails={orderDetails} />
          </div>
        )}

        <div className={classes.buttonContainer}>
          <Button
            variant="primary"
            type="button"
            to="/customer/prepaid-cards?show=history"
            dataT1="success_page__button"
          >
            {__("Przejdź do innych realizacji")}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Success;
